// @flow

import type { IHasTemplate } from '../../interfaces/IhasTemplate';

export default class InteractionBlocker implements IHasTemplate {
  /**
   * @inheritDoc
   */
  static template(): HTMLElement {
    const template = document.createElement('div');
    template.className = 'interaction__blocker absolute inset-0 bg-transparent';
    return template;
  }
}
